import emoji from './emojis.json'

export default {
  methods: {
    calcEmotions (emotions) {
      let newArray = []

      for (let key in emotions) {
        let newItem = {}

        for (let i = 0; i < emoji.length; i++) {
          if (emoji[i].name === key) {
            newItem = {
              name: emoji[i].name,
              img: emoji[i].img
            }
          }
        }

        newArray.push({
          value: emotions[key] !== null ? Math.round(emotions[key] * 100) : null,
          ...newItem
        })
      }

      return newArray
    },

    calcMainEmotion (emotions) {
      let newItem = {
        name: 'notRecognized',
        title: 'notRecognized',
        img: emoji[5].img,
        value: 0
      }
      let newValue = {
        value: 0,
        name: ''
      }

      for (let key in emotions) {
        if (emotions[key] > newValue.value) {
          newValue = {
            value: emotions[key],
            name: key
          }
        }
      }

      for (let i = 0; i < emoji.length; i++) {
        if (emoji[i].name === newValue.name) {
          newItem = {
            title: emoji[i].title,
            name: emoji[i].name,
            img: emoji[i].img,
            value: Math.round(newValue.value * 100)
          }
        }
      }

      return newItem
    }
  }
}
